<script setup lang="ts">
import {useInterviewStore} from "@/stores/interview-store";
import {storeToRefs} from "pinia";
import InterviewGuidelines from "@/interview/components/instance-modal/InterviewGuidelines.vue";
import InterviewConsumerNoteInput from "@/interview/components/instance-modal/InterviewConsumerNoteInput.vue";
import CustomerDrugInteractionHeader
    from "@/drug-interaction/components/header/CustomerDrugInteractionHeader.vue";

const interviewStore = useInterviewStore();
const {interview} = storeToRefs(interviewStore);

</script>

<template>
  <div v-if="!interview">
    <p>Oups...</p>
  </div>
  <div v-else class="flex flex-col w-full gap-4">
    <CustomerDrugInteractionHeader
      v-if="interviewStore.consumerKey"
      class="shadow-xl"
      :consumer-key="interviewStore.consumerKey"
      :customer-id="interviewStore.customerId as number"
      @track-products="$router.push({
        name: 'interview-instances.consumer-product-tracking',
        query: {...$route.query},
      })"
    />
    <div class="flex gap-x-6">
      <div class="flex-1 self-start">
        <InterviewGuidelines />
        <p class="flex flex-1 py-4 text-primary justify-center text-center">
          💡N’oubliez pas de réaliser une analyse pharmaceutique afin de détecter d’éventuelles interactions
          médicamenteuses
        </p>
      </div>
      <slot name="shortcuts" />
    </div>
    <div class="flex-1" />
    <InterviewConsumerNoteInput
      v-if="interviewStore.interviewInstance"
      class="bottom-0 w-full"
      :interview-instance="interviewStore.interviewInstance"
    />
  </div>
</template>
